import { render, staticRenderFns } from "./WidgetBody.vue?vue&type=template&id=7b6c34a7&scoped=true"
import script from "./WidgetBody.vue?vue&type=script&lang=js"
export * from "./WidgetBody.vue?vue&type=script&lang=js"
import style0 from "./WidgetBody.vue?vue&type=style&index=0&id=7b6c34a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c34a7",
  null
  
)

export default component.exports